var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2422 1.67188H12.5391V1.08594C12.5391 0.762333 12.2767 0.5 11.9531 0.5C11.6295 0.5 11.3672 0.762333 11.3672 1.08594V1.67188H3.63281V1.08594C3.63281 0.762333 3.37048 0.5 3.04688 0.5C2.72327 0.5 2.46094 0.762333 2.46094 1.08594V1.67188H1.75781C0.788498 1.67188 0 2.46037 0 3.42969V13.7422C0 14.7115 0.788498 15.5 1.75781 15.5H13.2422C14.2115 15.5 15 14.7115 15 13.7422V3.42969C15 2.46037 14.2115 1.67188 13.2422 1.67188ZM1.75781 2.84375H2.46094V3.42969C2.46094 3.75329 2.72327 4.01562 3.04688 4.01562C3.37048 4.01562 3.63281 3.75329 3.63281 3.42969V2.84375H11.3672V3.42969C11.3672 3.75329 11.6295 4.01562 11.9531 4.01562C12.2767 4.01562 12.5391 3.75329 12.5391 3.42969V2.84375H13.2422C13.5653 2.84375 13.8281 3.10662 13.8281 3.42969V4.83594H1.17188V3.42969C1.17188 3.10662 1.43475 2.84375 1.75781 2.84375ZM13.2422 14.3281H1.75781C1.43475 14.3281 1.17188 14.0653 1.17188 13.7422V6.00781H13.8281V13.7422C13.8281 14.0653 13.5653 14.3281 13.2422 14.3281Z",
    fill: "#EB3D26"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.a224078a.svg";
export { ForwardRef as ReactComponent };